import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tech-stack',
  templateUrl: './tech-stack.component.html',
  styleUrls: ['./tech-stack.component.scss']
})
export class TechStackComponent implements OnInit {
  current_year = new Date().getFullYear()
  constructor() { }

  ngOnInit(): void {
    this.scrollToTop()
  }

  scrollToTop(){
    const element = document.querySelector('.tech-stack-wrapper');
    if (element) {
        element.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'})
    }
  }
}
